import React, { useEffect, useState } from "react";
import { Download, Check } from "lucide-react";

export default function InstallPWA({ variant = "default" }) {
    const [prompt, setPrompt] = useState(null);
    const [installed, setInstalled] = useState(false);

    useEffect(() => {
        // Detect already installed (standalone)
        const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
        setInstalled(isStandalone);

        const onBeforeInstall = (e) => {
            e.preventDefault();
            setPrompt(e);
        };
        const onInstalled = () => { setInstalled(true); setPrompt(null); };
        window.addEventListener("beforeinstallprompt", onBeforeInstall);
        window.addEventListener("appinstalled", onInstalled);
        return () => {
            window.removeEventListener("beforeinstallprompt", onBeforeInstall);
            window.removeEventListener("appinstalled", onInstalled);
        };
    }, []);

    if (installed) {
        if (variant === "banner") return null;
        return (
            <span className="inline-flex items-center gap-1 text-xs text-emerald-600" data-testid="pwa-installed-indicator">
                <Check className="size-3" /> App installed
            </span>
        );
    }
    if (!prompt) return null;

    const install = async () => {
        prompt.prompt();
        const { outcome } = await prompt.userChoice;
        if (outcome === "accepted") setInstalled(true);
        setPrompt(null);
    };

    if (variant === "banner") {
        return (
            <div className="surface p-3 mb-3 flex items-center justify-between gap-3" data-testid="pwa-banner">
                <div className="flex items-center gap-3">
                    <div className="size-9 rounded-md bg-primary/10 text-primary flex items-center justify-center"><Download className="size-5" /></div>
                    <div>
                        <div className="font-display font-semibold text-sm">Install SAHOD</div>
                        <div className="text-xs text-muted-foreground">Add the app to your home screen for offline clock-in and faster access.</div>
                    </div>
                </div>
                <button onClick={install} className="h-9 px-3 rounded-md bg-primary text-white text-sm font-medium" data-testid="pwa-install-banner-btn">Install</button>
            </div>
        );
    }

    return (
        <button onClick={install} className="h-9 px-3 rounded-md border border-border bg-background text-sm hover:bg-secondary inline-flex items-center gap-2" data-testid="pwa-install-btn">
            <Download className="size-4" /> Install App
        </button>
    );
}
